import { useState, useEffect } from 'react';

/**
 * Hook to initialize Sardine SDK for device fingerprinting and fraud prevention.
 * This should be called at the start of any KYC/KYB flow.
 */
export default function useSardine(clientId = 'mock-client-id') {
  const [sessionKey, setSessionKey] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    // Generate a unique session key for this onboarding session
    const generatedSessionKey = crypto.randomUUID();
    setSessionKey(generatedSessionKey);

    // Load Sardine JS SDK
    const scriptId = 'sardine-sdk';
    if (!document.getElementById(scriptId)) {
      const script = document.createElement('script');
      script.id = scriptId;
      script.src = 'https://js.sardine.ai/sardine.js';
      script.async = true;
      
      script.onload = () => {
        setIsLoaded(true);
        // Initialize Sardine (mock initialization since we don't have real keys yet)
        if (window._Sardine) {
          window._Sardine.createContext({
            clientId: clientId,
            sessionKey: generatedSessionKey,
            environment: 'sandbox' // 'sandbox' or 'production'
          });
        } else {
          console.log('[Sardine Mock] Sardine SDK loaded successfully. Context created with sessionKey:', generatedSessionKey);
        }
      };

      script.onerror = () => {
        console.error('Failed to load Sardine SDK');
      };

      document.head.appendChild(script);
    } else {
      setIsLoaded(true);
    }

    return () => {
      // Cleanup if necessary
    };
  }, [clientId]);

  return { sessionKey, isLoaded };
}
